var slider = null;
var sliderHello = null;
jQuery(document).ready(function ($) {
 /*
  $(function() {
		  var actionBtn = $('.cart__checkout-button');
		 	$(window).on('load', function () {
	            actionBtn.prop("disabled", true);
			});
            jQuery('#confirm-checkbox').change(function() {
				console.log('check');
                if($('#confirm-checkbox').prop("checked") == true) {
                    actionBtn.prop("disabled", false);
                } else {
                    actionBtn.prop("disabled", true);
                }
            });
	 });
  */
  
    $(window).on('load resize', function () {
        objectFitImages();
        var wid = window.innerWidth;
      //console.log(collectionArrow);
      
        var collectionArrow = $('.collection-slider-item .imgbox').innerHeight();
      setTimeout(function(){
        collectionArrow = $('.collection-slider-item .imgbox').innerHeight();
       // console.log(collectionArrow); 
          $('.swiper-button-next').css("top", collectionArrow / 2);
        $('.swiper-button-prev').css("top", collectionArrow / 2);
      },100);
      setTimeout(function(){
        $('.collection-slider-contents').css("visibility", "visible");
      },30);
        /* product page slider */
        /*if (wid < 768) {
            const mySwiper = new Swiper('.swiper-container', {
                initialSlide: 0,
                speed: 1000,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction'
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            });
        } else if (wid > 767) {
            const thumbClass = 'thumblist-item';
            const mytap = window.ontouchstart === null ? "touchstart" : "click";

            const mySwiper = new Swiper('.swiper-container', {
                speed: 1500,
               navigation: {
                 nextEl: '.swiper-button-next',
                 prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.thumblist',
                    type: 'custom',
                    renderCustom: function (swiper, current, total) {
                        const slides = swiper.slides;
                        let html = '';
                        for (let i = 0; i < total; i++) {
                            if (current == i + 1) {
                                html = html + `<div class="${thumbClass} current" data-slideto="${i}">${slides[i].innerHTML}</div>`;
                            } else {
                                html = html + `<div class="${thumbClass}" data-slideto="${i}">${slides[i].innerHTML}</div>`;
                            }
                        }
                        return html;
                    }
                },
            });

            const clickThumbs = (() => {
                const thumbItems = document.getElementsByClassName(thumbClass);
                for (let i = 0; i < thumbItems.length; i++) {
                    thumbItems[i].addEventListener(mytap, ((e) => {
                        let index = e.currentTarget.dataset.slideto;
                        mySwiper.slideTo(index, 1500, true);
                    }), false);
                }
            });

            clickThumbs();
            mySwiper.on('slideChange', clickThumbs);
        }*/

                 /*var sliderThumbnail = new Swiper('.thumbnail-swiper', {
                  slidesPerView: 3.4,
                  freeMode: true,
                  watchSlidesVisibility: true,
                  watchSlidesProgress: true,
                 spaceBetween: 2,
                 navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                  },
                });
				
                //スライダー
                var slider = new Swiper('.product-swiper', {
                  slidesPerView: 1.2,
                  centeredSlides: true,
                 spaceBetween: 10,
                  navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                  },
                  pagination: {
                      el: '.swiper-pagination',
                      type: 'fraction'
                  },
                  thumbs: {
                    swiper: sliderThumbnail
                  },
                  breakpoints: {
                      767: {
		                spaceBetween: 0,
                        slidesPerView: 1,
                      },
                  },
                });*/

        /* fv slider*/
        if (typeof Swiper !== 'undefined' && document.querySelector('.swiper-fv-container')) {
            const swiper2 = new Swiper('.swiper-fv-container', {
                effect: "fade",
                direction: 'horizontal',
                loop: true,
                speed: 3000,
                slidesPerView: 1,
                loopedSlides: 4,
                autoplay: { delay: 3000, disableOnInteraction: false, },
                breakpoints: {
                    767: {
                        effect: "fade",
                        direction: 'horizontal',
                        loop: true,
                        speed: 3000,
                        slidesPerView: 1,
                        loopedSlides: 4,
                        autoplay: { delay: 3000, disableOnInteraction: false, }
                    },
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true
                }
            });
        }

        /* collection */
        if (typeof Swiper !== 'undefined' && document.querySelector('.swiper-collection-slider-container')) {
            const swiper3 = new Swiper('.swiper-collection-slider-container', {
                direction: 'horizontal',
                loopedSlides: 6,
                spaceBetween: 10,
                slidesPerView: 2.2,
	                navigation: {
	                    nextEl: '.swiper-svg-next',
	                    prevEl: '.swiper-svg-prev'
	                },
                breakpoints: {
                  759: {
                        slidesPerView: 3.2,
                        centeredSlides: false,
                        spaceBetween: 30,
                    },
                    989: {
                        slidesPerView: 4.2,
                        centeredSlides: false,
                        spaceBetween: 30,
                    },
                },
            });
        }
        const swiperPrev = document.getElementsByClassName('swiper-button-prev-pretend');
        const swiperNext = document.getElementsByClassName('swiper-button-next-pretend');

        for (let i = 0; i < swiperPrev.length; i++) {
            swiperPrev[i].addEventListener('click', (e) => {
                const parent = e.target.parentNode;
                const prev = parent.getElementsByClassName('swiper-button-prev')[0];
                prev.click();
            });
        }
      

        for (let i = 0; i < swiperNext.length; i++) {
            swiperNext[i].addEventListener('click', (e) => {
                const parent = e.target.parentNode;
                const next = parent.getElementsByClassName('swiper-button-next')[0];
                next.click();
            });
        }
        /* featured */
        if (typeof Swiper !== 'undefined' && document.querySelector('.swiper-featured-container')) {
            const swiper4 = new Swiper('.swiper-featured-container', {
                direction: 'horizontal',
                loop: true,
	                loopedSlides: 4,
                spaceBetween: 20,
                slidesPerView: 2.5,
                centeredSlides: false,
                preloadImages: false, //画像の先読みを無効に
	                lazy: true, // Lazy Loading を有効に
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    767: {
                        slidesPerView: 4,
                        spaceBetween: 30,
                        centeredSlides: true,
                    },
                },
            });
        }
      function initProductGalleries(root) {
        if (typeof Swiper === 'undefined') return;

        root.querySelectorAll('media-gallery.product-gallery').forEach(function (gallery) {
          var mainElement = gallery.querySelector('.product-swiper');
          if (!mainElement || mainElement.swiper) return;

          var thumbnailElement = gallery.querySelector('.thumbnail-swiper');
          var caption = gallery.querySelector('.product-gallery-caption');
          var previousButton = gallery.querySelector('.product-gallery-arrow--prev');
          var nextButton = gallery.querySelector('.product-gallery-arrow--next');
          var pagination = gallery.querySelector('.product-gallery-pagination');
          var thumbnailSwiper = null;

          if (thumbnailElement) {
            thumbnailSwiper = new Swiper(thumbnailElement, {
              direction: 'horizontal',
              slidesPerView: 'auto',
              spaceBetween: 10,
              watchSlidesProgress: true,
              breakpoints: {
                760: { direction: 'vertical' }
              },
              mousewheel: {
                enabled: true,
                eventsTarget: gallery.querySelector('.thumbnail-swiper-wrap'),
                releaseOnEdges: true
              },
              scrollbar: {
                el: gallery.querySelector('.product-gallery-scrollbar'),
                draggable: true
              }
            });
          }

          var options = {
            slidesPerView: 1,
            spaceBetween: 0,
            on: {
              init: updateProductCaption,
              slideChange: updateProductCaption
            }
          };

          if (previousButton && nextButton) {
            options.navigation = { prevEl: previousButton, nextEl: nextButton };
          }
          if (pagination) {
            options.pagination = { el: pagination, type: 'bullets', clickable: true };
          }
          if (thumbnailSwiper) {
            options.thumbs = { swiper: thumbnailSwiper };
          }

          function updateProductCaption(swiper) {
            if (!caption) return;
            var activeSlide = swiper.slides[swiper.activeIndex];
            caption.textContent = activeSlide ? activeSlide.dataset.mediaCaption || '' : '';
          }

          slider = new Swiper(mainElement, options);
        });
      }

      initProductGalleries(document);
      document.addEventListener('shopify:section:load', function (event) {
        initProductGalleries(event.target);
      });
      document.addEventListener('shopify:section:unload', function (event) {
        event.target.querySelectorAll('media-gallery.product-gallery').forEach(function (gallery) {
          var main = gallery.querySelector('.product-swiper');
          var thumbnails = gallery.querySelector('.thumbnail-swiper');
          if (main && main.swiper) main.swiper.destroy(true, true);
          if (thumbnails && thumbnails.swiper) thumbnails.swiper.destroy(true, true);
        });
      });
      var sliderThumbnailHello = null;
      var helloThumb = $('.thumbnail-hello-swiper');
      var helloProduct = $('.product-hello-swiper');
      var helloThumbNext = $('.thumbnail-swiper-wrap').find('.swiper-button-next');
      var helloThumbPrev = $('.thumbnail-swiper-wrap').find('.swiper-button-prev');
      var helloProductNext = $('.product-hello-swiper').find('.swiper-button-next');
      var helloProductPrev = $('.product-hello-swiper').find('.swiper-button-prev');
      if(typeof Swiper !== 'undefined') {
        for (let i = 0; i < helloThumb.length; i++) {
            sliderThumbnailHello = new Swiper(helloThumb[i], {
                slidesPerView: 3.4,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
               spaceBetween: 2,
               initialSlide: 0,
               mousewheel: {
                 enabled: true,
                 eventsTarget: helloThumb[i].parentElement,
                 releaseOnEdges: true
               },
               navigation: {
                  nextEl: helloThumbNext[i],
                  prevEl: helloThumbPrev[i],
                },
              });
        //スライダー
            slider = new Swiper(helloProduct[i], {
              slidesPerView: 1.2,
              centeredSlides: true,
             spaceBetween: 10,
              navigation: {
                nextEl: helloProductNext[i],
                prevEl: helloProductPrev[i],
              },
              pagination: {
                  el: '.swiper-pagination',
                  type: 'fraction'
              },
              thumbs: {
                swiper: sliderThumbnailHello
              },
              breakpoints: {
                  767: {
                    spaceBetween: 0,
                    slidesPerView: 1,
                  },
              },
            });
        }
      }
         

        /*==================================================
          LINE追従バナー
          ==================================================*/
        var closeBtn = $('#lineBnrClose');
        var floatingBannerStorageKey = 'floating_bnr_closed';
        var isFloatingBannerClosed = function () {
            try {
                return window.localStorage.getItem(floatingBannerStorageKey) === 'closed';
            } catch (error) {
                return false;
            }
        };
        var closeFloatingBanner = function () {
            try {
                window.localStorage.setItem(floatingBannerStorageKey, 'closed');
            } catch (error) {}
        };
    
        $('.following-bnr').hide();
        $(window).scroll(function () {
            var bnrHeight = $(".following-bnr").innerHeight();
            var pagetopBottom = bnrHeight + 30;
            if ($(this).scrollTop() > 100 && !isFloatingBannerClosed()) {
                var p = $('.following-bnr').hasClass('close');
                $("#loyaltyLauncher").css("bottom", "20px");
                if( p ) {}else{
                $(".following-bnr").fadeIn();
                  $("#loyaltyLauncher").css("bottom", "150px");
                }
                $(".pagetop").css("bottom", pagetopBottom);
        
            } else {
                $(".following-bnr").fadeOut();
                $("#loyaltyLauncher").css("bottom", "20px");
            }
        });
        $(document).on('click', '#lineBnrClose', function () {
    		$(this).parent().parent().addClass('close');
    		$(this).parent().parent().fadeOut();
            $("#loyaltyLauncher").css("bottom", "20px");
            closeFloatingBanner();
    	});
            /*==================================================
          モーダル
          ==================================================*/
          //開くボタンをクリックしたらモーダルを表示する
          $('.modal-switch').on('click', function () {
              var modalCode = $(this).data('popup');
              $('.modal-main').each(function(){
                if($(this).hasClass(modalCode)) {
                    $(this).addClass('active');
                }
      			});
              return false;
          });
      
          //閉じるボタンをクリックしたらモーダルを閉じる
          $('.modal-close-btn').on('click', function () {
            var modalCodePre = $(this).parents('.modal-main').attr('class');
            var modalCodePreArray = modalCodePre.split(' ');
            var modalCode = modalCodePreArray[1];
            $('.modal-main').each(function(){
              if($(this).hasClass(modalCode)) {
                    $(this).removeClass('active');
                }
              });
          });
      
          //モーダルの外側をクリックしたらモーダルを閉じる
          $(document).on('click', function (e) {
              if (!$(e.target).closest('.modal-body').length) {
                  $('.modal-main').each(function(){
                    $(this).removeClass('active');
                });
              }
          });
        /* scroll */
        $(window).on('load scroll resize', function () {
            var wid = window.innerWidth;
            var fvWrap = $('.fv-wrap');
            var fvHeight = fvWrap.innerHeight();
            var header = $('header');
            var headerHeight = header.innerHeight();
            var yardstickHeight = fvHeight + headerHeight;
            if ($(this).scrollTop() > yardstickHeight) {
                if (!$('body').hasClass('-is-scroll')) {
                    $('body').addClass('-is-scroll');
                }
            } else {
                if ($('body').hasClass('-is-scroll')) {
                    $('body').removeClass('-is-scroll');
                }
            }
        });

        

        /* pagetop */
        var topBtn = $('#pagetop');
      var following = $('.following');
        topBtn.hide();
        following.hide();
        $(window).on('load scroll resize', function () {
            var wid = window.innerWidth;
            var header = $('header');
            var headerheight = header.innerHeight();
            if ($(this).scrollTop() > 100) {//スクロールが100に達したら
                topBtn.fadeIn();//ページトップのボタン表示
                following.fadeIn();
            } else {
                topBtn.fadeOut();
                following.fadeOut();
            }
        });
        //スクロールしてトップ
        topBtn.click(function () {
            $('body,html').animate({
                scrollTop: 0
            }, 500);
            return false;
        });

        /* animation triger */
        $(window).on('scroll', function () {
            $(".animation").each(function () {
                var position = $(this).offset().top;
                var scroll = $(window).scrollTop();
                var windowHeight = $(window).height();
                var plus = windowHeight * 0.3;
                if (scroll > position - windowHeight + plus) {
                    $(this).addClass("-is-active");
                } else {
                    //$(this).removeClass("-is-active");
                }
            });
        });
    });	
  	
	/*スムーススクロール*/
	

	// #で始まるリンクをクリックしたら実行されます
	$('a[href^="#"]').click(function () {
		// スクロールの速度
		var speed = 400; // ミリ秒で記述
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		$('body,html').animate({ scrollTop: position }, speed, 'swing');
		return false;
	});

  // アコーディオン
  $(".aco-switch").on("click", function () {
		if (!$(this).hasClass("active")) {

			var slide_height = $(this).next(".aco-container").children().innerHeight();


			$(this).next(".aco-container").css("height", slide_height);
		}

		$(this).toggleClass("active");
        $(this).parents('.list-article-contents').toggleClass("active");

		return false;
	});
  // アコーディオン
  $(".footer-block__heading").on("click", function () {
    console.log('dete');
		if (!$(this).hasClass("active")) {

			var slide_height = $(this).next(".footer-block__details-container").children().innerHeight();


			$(this).next(".footer-block__details-container").css("height", slide_height);
		}

		$(this).toggleClass("active");

		return false;
	});

	/*==================================================
	タブクリック
	==================================================*/
	$('.tab').on('click', function(){
        $('.tab, .panel').removeClass('-is-active');
        
        $(this).toggleClass('-is-active');
        
        var index = $('.tab').index(this);
        $('.panel').eq(index).toggleClass('-is-active');
    });
  
});
document.addEventListener('click', function (event) {
  if (!(event.target instanceof Element)) return;
  var sizeGuideLink = event.target.closest('.product__size-guide-link a[href="#product_contents"]');
  if (!sizeGuideLink) return;

  var productContents = document.getElementById('product_contents');
  if (!productContents) return;

  var productInformation = productContents.querySelector('.product-content-accordion');
  if (productInformation) productInformation.open = true;
});
window.addEventListener("load", function () {
  if($('.video-fv .video-wrapper > video').length) {
  	var fvVideo = $('.video-fv .video-wrapper > video');
  	fvVideo[0].play();
  }
});

document.addEventListener("DOMContentLoaded", function() {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.js-lazy-video"));
  var hydrateVideo = function(video) {
    if (video.dataset.loaded === 'true') return;

    var videoSrc = video.getAttribute('data-src');
    if (videoSrc && !video.getAttribute('src')) {
      video.setAttribute('src', videoSrc);
    }

    video.dataset.loaded = 'true';
    video.load();
  };

  var playLazyVideo = function(video) {
    if (video.offsetParent === null) return;

    hydrateVideo(video);
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function() {});
    }
  };

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        // 動画が画面内に入った場合
        if (video.isIntersecting) {
          window.setTimeout(function() {
            playLazyVideo(video.target);
          }, 1200);
        } else {
          // 【追加】画面外に出たら（または display:none になったら）一時停止する
          if (!video.target.paused) {
            video.target.pause();
          }
        }
      });
    });

    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  } else {
    // フォールバック（古いブラウザ用）
    lazyVideos.forEach(function(lazyVideo) {
      // display:none のものは再生しないようにチェックを入れる
      window.setTimeout(function() {
        playLazyVideo(lazyVideo);
      }, 1200);
    });
  }
});

(function () {
  function initFeatureCarousels(root) {
    if (typeof Swiper === 'undefined') return;

    root.querySelectorAll('#product_contents .product-feature-carousel__viewport').forEach(function (carousel) {
      if (carousel.dataset.featureCarouselBound === 'true') return;
      carousel.dataset.featureCarouselBound = 'true';

      var feature = carousel.closest('.product-feature-carousel');
      var details = carousel.closest('.product-content-accordion');
      var layout = carousel.closest('.product-feature-layout');
      var slides = Array.from(carousel.querySelectorAll('.swiper-wrapper > .swiper-slide'));
      var copyPanels = layout ? Array.from(layout.querySelectorAll('.product-feature-copy__panel')) : [];
      if (!feature || !details || !layout || slides.length !== copyPanels.length || slides.length < 2) return;

      var pagination = feature.querySelector('.product-feature-carousel__pagination');
      if (pagination) {
        slides.forEach(function (_, index) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'product-feature-carousel__page';
          button.dataset.slideIndex = index;
          button.setAttribute('aria-label', '特徴 ' + (index + 1) + ' を表示');
          button.setAttribute('aria-controls', carousel.id);
          pagination.appendChild(button);
        });
      }

      feature.addEventListener('click', function (event) {
        if (!carousel.swiper) return;

        if (event.target.closest('.product-feature-carousel__prev')) {
          carousel.swiper.slidePrev();
        } else if (event.target.closest('.product-feature-carousel__next')) {
          carousel.swiper.slideNext();
        } else {
          var page = event.target.closest('.product-feature-carousel__page');
          if (page) carousel.swiper.slideTo(Number(page.dataset.slideIndex));
        }
      });

      function updateControls(swiper) {
        copyPanels.forEach(function (panel, index) {
          var active = index === swiper.activeIndex;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', String(!active));
          panel.inert = !active;
        });
        var previousButton = carousel.querySelector('.product-feature-carousel__prev');
        var nextButton = carousel.querySelector('.product-feature-carousel__next');
        if (previousButton) previousButton.disabled = swiper.isBeginning;
        if (nextButton) nextButton.disabled = swiper.isEnd;
        feature.querySelectorAll('.product-feature-carousel__page').forEach(function (button) {
          var active = Number(button.dataset.slideIndex) === swiper.activeIndex;
          button.classList.toggle('is-active', active);
          if (active) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
      }

      function updateCarousel() {
        if (!details.open) return;

        requestAnimationFrame(function () {
          if (!details.open || !carousel.isConnected) return;

          if (carousel.swiper) {
            carousel.swiper.update();
            carousel.swiper.updateAutoHeight(0);
            return;
          }

          layout.classList.add('is-ready');
          new Swiper(carousel, {
            slidesPerView: 1,
            spaceBetween: 16,
            autoHeight: true,
            on: {
              init: updateControls,
              slideChange: updateControls
            }
          });
        });
      }

      details.addEventListener('toggle', updateCarousel);
      updateCarousel();
    });
  }

  initFeatureCarousels(document);
  document.addEventListener('shopify:section:load', function (event) {
    initFeatureCarousels(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('#product_contents .product-feature-carousel__viewport').forEach(function (carousel) {
      if (carousel.swiper) carousel.swiper.destroy(true, true);
    });
  });
})();
